var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"mt-5"},[_vm._v("Home page")]),_c('b-link',{attrs:{"to":"/login"}},[_vm._v(" Login")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }